import { render, staticRenderFns } from "./BalanceStatistics.vue?vue&type=template&id=15169cf4"
import script from "./BalanceStatistics.vue?vue&type=script&lang=js"
export * from "./BalanceStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports